import React, { Component } from 'react';
import PreviousBtn          from 'assets/icons/Previous.svg';
import NextBtn              from 'assets/icons/Next.svg';

class PageSelect extends Component {
  render() {
    return (
      <div className="ml-4 mb-0">
        <button onClick={ this.props.inherited.prevPage } style={{ border: "none", backgroundColor: "#F2F2F2" }}>
          <img src={ PreviousBtn } alt="previous" className="page-prev-btn" />
        </button>

        <b className="font-size-6 px-2">{ this.props.inherited.page } of { this.props.inherited.total_pages }</b>

        <button onClick={ this.props.inherited.nextPage } style={{ border: "none", backgroundColor: "#F2F2F2" }}>
          <img src={ NextBtn } alt="next" className="page-next-btn" />
        </button>
      </div>
    );
  }
}

class BookingAmounts extends Component {
  render() {
    const tagClasses  = 'text-white d-inline-block w-em-4 text-center py-1 mr-4';
    const wordClasses = 'mr-8';

    return (
      <div className="d-flex flex-wrap align-items-center">
        <div className="m-1">
          <span className={ tagClasses + ' bg-warning' }>{ this.props.stats.upcoming }</span>
          <span className={ wordClasses }>Upcoming</span>
        </div>

        <div className="m-1">
          <span className={ tagClasses + ' bg-success' }>{ this.props.stats.attended }</span>
          <span className={ wordClasses }>Attended</span>
        </div>

        <div className="m-1">
          <span className={ tagClasses + ' bg-primary' }>{ this.props.stats.cancelled }</span>
          <span className={ wordClasses }>Cancelled</span>
        </div>

        <div className="m-1">
          <span className={ tagClasses + ' bg-grey' }>{ this.props.stats.skipped }</span>
          <span className={ wordClasses }>Skipped</span>
        </div>
      </div>
    );
  }
}

export class PreregistrationOptions extends Component {
  render() {
    return (
      <div>
        <div className="d-flex align-items-end justify-content-end">
          <PageSelect inherited={ this.props } />
        </div>

        <div className="d-flex align-items-center pt-2">
          <BookingAmounts stats={ this.props.stats } />
        </div>
      </div>
    )
  }
}